// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"bb87ea54","218":"6eee7c37","490":"042ce0b1","795":"ce4f8ff0","879":"55dd3cc0"}[chunkId] + ".css";
};